function sendmail(mail, opt) {
	
   if (!mail) return '';
   var revstr='';
   for (i = mail.length-1; i>=0; i--)
	   revstr+=mail.charAt(i);
	
	location.href="mailto:"+revstr + (opt?opt:'');
}

function pPrintsendmail(mail) {
	if (!mail) return '';
	var revstr='';
	for (i = mail.length-1; i>=0; i--)
		revstr+=mail.charAt(i);
	document.write(revstr);
}